import React, { useEffect, useState, useRef, lazy } from 'react';
const CTA_URL = 'https://info.stresslessdogs.nl/webinar-mc-adv5';
export function BlogReactieveHondPage() {
  const [showSticky, setShowSticky] = useState(false);
  const trustboxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if ((window as any).Trustpilot && trustboxRef.current) {
      ;
      (window as any).Trustpilot.loadFromElement(trustboxRef.current, true);
    }
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past hero (approx 400px)
      if (window.scrollY > 400) {
        setShowSticky(true);
      } else {
        setShowSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen font-serif" style={{
    backgroundColor: '#FAFAF7',
    color: '#2A2A28',
    fontFamily: 'Georgia, serif'
  }} data-id="element-1302" data-mp="1phj6b05gf01p">
      {/* Slim brand bar */}
      <header className="border-b" style={{
      borderColor: '#E5E3DC'
    }} data-id="element-1303" data-mp="icmxjc54rfa7">
        <div className="max-w-[680px] lg:max-w-5xl mx-auto px-4 py-4 flex justify-center lg:justify-start" data-id="element-1304" data-mp="mdox5u2yltcp">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-8 object-contain" data-id="element-1305" data-mp="rf5wvm9pj9rp" />
        </div>
      </header>

      <main className="max-w-[680px] lg:max-w-5xl mx-auto px-4 py-8 lg:py-12 flex flex-col lg:flex-row gap-12 pb-32 lg:pb-20" data-id="element-1306" data-mp="3o0izcnburk1">
        {/* Left Column: Article */}
        <article className="w-full lg:max-w-[680px]" data-id="element-1307" data-mp="8m22tzskuuwk">
          <div className="uppercase tracking-widest font-semibold mb-4" style={{
          color: '#2E7D5B',
          fontSize: '13px',
          letterSpacing: '0.08em'
        }} data-id="element-1308" data-mp="dfd8vypkf7nf">
            GEDRAG & WELZIJN
          </div>

          <h1 className="text-[30px] md:text-[40px] font-bold leading-[1.2] mb-6 text-[#2A2A28]" data-id="element-1309" data-mp="39279u8fp1yyx">
            Is je hond reactief naar andere honden? De oorzaak ligt vaak ergens
            anders dan je denkt
          </h1>

          <div className="mb-8 text-[#777] text-[13px] font-sans" data-id="element-1310" data-mp="3isaej5w6h1d3">
            Redactie · leestijd 3 min
          </div>

          <figure className="mb-8 -mx-4 md:mx-0" data-id="element-1311" data-mp="3dvs9s60ul30r">
            <img src="https://cdn.magicpatterns.com/uploads/w7QvFMYsgefH7ybanNjydH/magnific__inhoud-een-hond-aan-de-lijn-met-een-gespannen-houd__12444.png" alt="Hond aan de lijn die gespannen reageert op een andere hond." className="w-full h-auto md:rounded-lg" loading="lazy" data-id="element-1312" data-mp="2q3cy78bj1emz" />
          </figure>

          <p className="text-[19px] md:text-[20px] leading-[1.7] mb-10 font-medium" data-id="element-1313" data-mp="fc38isqais15">
            Je loopt rustig met je hond, tot er in de verte een andere hond
            opduikt. Je hond begint te blaffen, grommen, happen of springt in de
            riem. Heel veel baasjes herkennen dit - en denken dan al snel dat
            hun hond dominant of koppig is.{' '}
            <span style={{
            backgroundColor: '#DCEEE4'
          }} data-id="element-1314" data-mp="1xazwjdsde82f">
              Toch zien gedragsdeskundigen steeds vaker dat hier een heel andere
              oorzaak achter zit.
            </span>
          </p>

          <h2 className="text-[22px] md:text-[26px] font-bold leading-tight mt-12 mb-6 text-[#2A2A28]" data-id="element-1315" data-mp="2bznm93fjbnkg">
            Het is geen dominantie - en dat is wetenschappelijk achterhaald
          </h2>

          <p className="text-[17px] md:text-[18px] leading-[1.7] mb-6" data-id="element-1316" data-mp="229kt938ey9m4">
            Het idee dat je "de baas" of "de alfa" over je hond moet zijn, komt
            uit oud wolvenonderzoek uit de jaren zeventig. Maar dat onderzoek
            werd gedaan bij wolven die in gevangenschap{' '}
            <strong data-id="element-1317" data-mp="2zof87d2j79os">kunstmatig bij elkaar waren gezet</strong> - en juist dáár
            kwam al dat vechten en die "dominantie" vandaan. Wolvenbioloog David
            Mech, die wolven decennialang in het wild bestudeerde, nam er zelf
            afstand van.
          </p>

          <blockquote className="pl-6 my-8 text-[22px] md:text-[26px] italic" style={{
          borderLeft: '4px solid #2E7D5B'
        }} data-id="element-1318" data-mp="121eedfdidos2">
            "In een natuurlijke wolvenroedel is de alfaleider gewoon de ouder."
            <footer className="text-[16px] mt-2 not-italic text-gray-600" data-id="element-1319" data-mp="1ts2c0hfz4c0z">
              - David Mech, wolvenbioloog
            </footer>
          </blockquote>

          <p className="text-[17px] md:text-[18px] leading-[1.7] mb-10" data-id="element-1320" data-mp="1kzqs7efd7mtz">
            En honden, zo benadrukken experts, zijn bovendien{' '}
            <strong data-id="element-1321" data-mp="1fzcrkhg3ff5z">helemaal geen wolven</strong>. Volgens gedragsdeskundige
            Amee de Bruijn heeft reactief gedrag dan ook niets met dominantie te
            maken.
          </p>

          <h2 className="text-[22px] md:text-[26px] font-bold leading-tight mt-12 mb-6 text-[#2A2A28]" data-id="element-1322" data-mp="28otfb1srq7vv">
            De echte oorzaak: stress en een hond die zich niet begrepen voelt
          </h2>

          <p className="text-[17px] md:text-[18px] leading-[1.7] mb-6" data-id="element-1323" data-mp="2l0m3fvbp77rb">
            Wat er volgens haar wél speelt, is{' '}
            <strong data-id="element-1324" data-mp="2q1ta1r23u0we">onzekerheid en stress</strong>. "Een hond die niet lekker in
            zijn vel zit, reageert net als een mens sneller fel," legt De Bruijn
            uit. Een vaak onderschatte reden daarvoor:{' '}
            <span style={{
            backgroundColor: '#DCEEE4'
          }} data-id="element-1325" data-mp="33yyanbj1u7k9">
              onze manier van communiceren botst met die van de hond.
            </span>{' '}
            Wij praten, gebaren en knuffelen, terwijl honden vooral{' '}
            <strong data-id="element-1326" data-mp="3hqmphmkona4x">met hun lichaam 'spreken'</strong> - met hun ogen, hun
            houding en de manier waarop ze hun kop draaien. Die signalen ontgaan
            ons meestal, waardoor we onbedoeld keuzes maken die de hond spanning
            bezorgen. En die spanning stapelt zich op. Dan is een andere hond,
            fietser, hardloper, voorbij rijdende auto of die bezoeker aan de
            deur ineens teveel.
          </p>

          <figure className="mb-10 mt-8" data-id="element-1327" data-mp="1web6emn2abev">
            <img src="https://cdn.magicpatterns.com/uploads/tcfzWBVc69BqWnAeJXf8dG/magnific__inhoud-een-closeup-van-hondse-lichaamstaal-bijvoor__12445.png" alt="Hond toont een kalmerend signaal: lip likken en afgewend hoofd." className="w-full h-auto rounded-lg" loading="lazy" data-id="element-1328" data-mp="1wfcjsxrjv9zr" />
          </figure>

          {/* Inline CTA 1 */}
          <div className="my-10 bg-white p-6 rounded-lg border border-[#E5E3DC] text-center lg:hidden" data-id="element-1329" data-mp="2fa18saywp9ta">
            <h3 className="font-bold text-xl mb-3 font-sans" data-id="element-1330" data-mp="2ab7vaijmdit4">
              Gratis Webinar: Communiceren met je hond
            </h3>
            <p className="mb-5 text-[16px] font-sans text-gray-600" data-id="element-1331" data-mp="fzjaw0umco1c">
              Leer de subtiele signalen van je hond herkennen en begrijpen.
            </p>
            <a href={CTA_URL} className="inline-block w-full bg-[#2E7D5B] hover:bg-[#256A4C] text-white font-sans font-bold py-4 px-6 rounded-md transition-colors text-[18px]" data-id="element-1332" data-mp="2rog1cv9fk92q">
              Meld je gratis aan voor het webinar
            </a>
            <p className="text-[13px] text-gray-500 mt-3 font-sans" data-id="element-1333" data-mp="2mttsayqtmslt">
              Gratis · online
            </p>
          </div>

          <h2 className="text-[22px] md:text-[26px] font-bold leading-tight mt-12 mb-6 text-[#2A2A28]" data-id="element-1334" data-mp="2duym3mns1iii">
            Waarom straffen of corrigeren averechts werkt
          </h2>

          <p className="text-[17px] md:text-[18px] leading-[1.7] mb-10" data-id="element-1335" data-mp="1zxa18etpmbdg">
            De reflex van veel baasjes is om in te grijpen en te corrigeren.
            "Meeste baasjes merken al dat dit eigenlijk niet werkt, het pakt
            namelijk niet de oorzaak aan," waarschuwt De Bruijn. "Nog
            belangrijker, straffen veroorzaakt{' '}
            <strong data-id="element-1336" data-mp="2m1q0vyb11g1x">
              extra stress en beschadigt juist de band met je hond
            </strong>
            ."{' '}
            <span style={{
            backgroundColor: '#DCEEE4'
          }} data-id="element-1337" data-mp="2h2vhau58jngr">
              Het werkt zelfs averechts.
            </span>
          </p>

          <h2 className="text-[22px] md:text-[26px] font-bold leading-tight mt-12 mb-6 text-[#2A2A28]" data-id="element-1338" data-mp="27bsijyzs3kkn">
            De oplossing zit in de taal van je hond
          </h2>

          <p className="text-[17px] md:text-[18px] leading-[1.7] mb-10" data-id="element-1339" data-mp="1ybcdwm7au7e7">
            De sleutel is <strong data-id="element-1340" data-mp="1tcj4p5z1p2ju">leren lezen wat je hond je vertelt</strong>.
            Wie de signalen herkent, ziet waar zijn hond rustig of juist
            gespannen van wordt - en kan daar rekening mee houden. Een kop die
            omlaag hangt is bijvoorbeeld lang niet altijd "lief"; vaak is het
            juist ongemak. Een écht ontspannen hond heeft een losjes geopende
            bek. De ene hond geniet van een drukke markt, de andere raakt er
            overprikkeld. Dat verschil zie je pas als je hem kunt lezen - en{' '}
            <span style={{
            backgroundColor: '#DCEEE4'
          }} data-id="element-1341" data-mp="3v90auwf37mx6">
              pas dan kun je hem helpen ontspannen.
            </span>
          </p>

          <h2 className="text-[22px] md:text-[26px] font-bold leading-tight mt-12 mb-6 text-[#2A2A28]" data-id="element-1342" data-mp="8tf9bwvtnusm">
            Wat je hieraan kunt doen
          </h2>

          <p className="text-[17px] md:text-[18px] leading-[1.7] mb-12" data-id="element-1343" data-mp="3cb775rwn38yq">
            De rode draad: je hond hoeft niet gecorrigeerd te worden, maar
            begrepen. Rust ontstaat door communicatie. In een gratis webinar
            legt Amee de Bruijn haar methode stap voor stap uit - inmiddels
            volgden ruim 100.000 hondenbezitters het.{' '}
            <a href={CTA_URL} className="text-[#2E7D5B] font-bold underline hover:text-[#256A4C]" data-id="element-1344" data-mp="wk2vnn6himyp">
              Je kunt je kosteloos aanmelden via deze pagina.
            </a>
          </p>

          {/* Expert credibility - Amee de Bruijn */}
          <div className="flex items-center gap-4 my-10 py-6 border-t border-b" style={{
          borderColor: '#E5E3DC'
        }} data-id="element-1345" data-mp="3420yam2pdyyd">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn, gedragsdeskundige" className="w-20 h-20 rounded-full object-cover flex-shrink-0" loading="lazy" data-id="element-1346" data-mp="3cvvydfoywz75" />
            <div data-id="element-1347" data-mp="2p4qfernqdqsm">
              <p className="font-bold text-[18px] text-[#2A2A28]" data-id="element-1348" data-mp="2p8eahv8tql9g">
                Amee de Bruijn
              </p>
              <p className="text-[15px] text-gray-600 font-sans" data-id="element-1349" data-mp="4fu9nm9gl6l8">
                Gediplomeerd hondengedragsdeskundige - maakte de gratis webinar
                'Communiceren met je hond'.
              </p>
            </div>
          </div>

          {/* Final Prominent CTA Block */}
          <div className="bg-white p-8 rounded-xl text-center mb-8" style={{
          border: '2px solid #E5E3DC'
        }} data-id="element-1350" data-mp="jkonf4utsh9c">
            <h3 className="text-[24px] font-bold mb-4 text-[#2A2A28]" data-id="element-1351" data-mp="9rhn3yexzrg4">
              Leer de taal van je hond
            </h3>
            <p className="text-[18px] mb-8 text-gray-600" data-id="element-1352" data-mp="5pml0rp6ta1a">
              Ontdek in dit gratis online webinar hoe je reactief gedrag oplost
              door je hond écht te begrijpen.
            </p>
            <a href={CTA_URL} className="inline-block w-full md:w-auto bg-[#2E7D5B] hover:bg-[#256A4C] text-white font-sans font-bold py-4 px-10 rounded-md transition-colors text-[18px] shadow-sm" data-id="element-1353" data-mp="3s109x81mflbi">
              Bekijk beschikbaarheid
            </a>
            <p className="text-[14px] text-gray-500 mt-4 font-sans text-center leading-relaxed" data-id="element-1354" data-mp="1l5v6or2nxkqc">
              <span className="inline-block w-2 h-2 bg-green-500 rounded-full align-middle mr-2" data-id="element-1355" data-mp="1h4i36nn1ltml"></span>
              Gratis · online · al ruim <strong data-id="element-1356" data-mp="3fgl71ermrvbv">100.000 hondenbezitters</strong>{' '}
              deden mee
            </p>
            <div className="mt-6 pt-6 border-t" style={{
            borderColor: '#E5E3DC'
          }} data-id="element-1357" data-mp="31owsl4twsurq">
              <div ref={trustboxRef} className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-theme="light" data-id="element-1358" data-mp="35qi3wlqsp0zt">
                <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-1359" data-mp="3pceg2o6556ow">
                  Trustpilot
                </a>
              </div>
            </div>
          </div>
        </article>

        {/* Right Column: Desktop Sticky Sidebar */}
        <aside className="hidden lg:block w-[300px] flex-shrink-0" data-id="element-1360" data-mp="21h89n4l1j5yq">
          <div className={`sticky top-8 transition-opacity duration-300 ${showSticky ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-id="element-1361" data-mp="2fg7wq7swncss">
            <div className="bg-white p-6 rounded-xl border border-[#E5E3DC] shadow-sm" data-id="element-1362" data-mp="2ahoa056hlwzd">
              <div className="uppercase tracking-widest font-semibold mb-2" style={{
              color: '#2E7D5B',
              fontSize: '12px',
              letterSpacing: '0.08em'
            }} data-id="element-1363" data-mp="1msc53hi70b2v">
                Gratis Webinar
              </div>
              <h3 className="font-bold text-[20px] mb-3 text-[#2A2A28] leading-tight" data-id="element-1364" data-mp="1rpcb5sf1ldtz">
                Communiceren met je hond
              </h3>
              <p className="text-[15px] mb-6 text-gray-600 leading-relaxed font-sans" data-id="element-1365" data-mp="z2htt4diuukq">
                Leer vloeiend in Hondentaal en ontdek waarom je hond doet wat
                hij doet.
              </p>
              <a href={CTA_URL} className="block w-full bg-[#2E7D5B] hover:bg-[#256A4C] text-white text-center font-sans font-bold py-4 px-4 rounded-md transition-colors text-[16px]" data-id="element-1366" data-mp="78wd8n5g2y38">
                Meld je gratis aan
              </a>
              <p className="text-[13px] text-gray-500 mt-3 font-sans text-center" data-id="element-1367" data-mp="l1cfvmufou3m">
                Gratis · online · <strong data-id="element-1368" data-mp="pznsg5c45ipj">al ruim 100.000 deelnemers</strong>
              </p>
            </div>
          </div>
        </aside>
      </main>

      {/* Mobile Sticky Bottom Bar */}
      <div className={`lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-[#E5E3DC] p-4 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] transition-transform duration-300 z-50 ${showSticky ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-1369" data-mp="uxfgupdjumoz">
        <a href={CTA_URL} className="block w-full bg-[#2E7D5B] hover:bg-[#256A4C] text-white text-center font-sans font-bold py-3 px-4 rounded-md transition-colors text-[15px] leading-snug" data-id="element-1370" data-mp="30t02aobtn486">
          Vandaag &amp; morgen: gratis webinar "Communiceren Met Je Hond"
        </a>
      </div>
    </div>;
}